import { FirstOrderCheckBoxProps } from '../interface/interface';

export default function FirstOrderCheckBox(
  props: Readonly<FirstOrderCheckBoxProps>,
) {
  return (
    <>
      <input
        type="checkbox"
        className="ml-4"
        checked={!!props?.firstOrderFilter}
        onChange={() => {
          props.setFirstOrderFilter!((prev) => !prev),
            props.setGuestOrderFilter!(false);
        }}
      />
      <p className="text-base text-primary-blue-500 ml-1">First Order</p>
    </>
  );
}
